export default "__VITE_ASSET__yVAwnBzr__"